import { useCallback, FocusEvent } from 'react'

const useValidatorHandlers = (
  setIsScenarioNameEmpty: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const onFocusOutCallback = useCallback(
    (e: FocusEvent<HTMLInputElement>) => {
      if (!e.target.value) {
        setIsScenarioNameEmpty(true)
      }
    },
    [setIsScenarioNameEmpty]
  )

  const validatorHandlers = {
    onFocusOut: onFocusOutCallback
  }

  return validatorHandlers
}

export { useValidatorHandlers }
